import { get } from 'lodash/fp';
import axios from './axios';
import config from '../../helpers/config';

export default (designId, itemId, attributeId, value, reason = null) => (
  axios.post(
    `${config.designBuilderSetItemAttributePath}/${designId}/items/${itemId}/attribute`,
    { attributeId, value, reason },
  ).then(get('data'))
);
